export const TEAM = [
  {
    name: "T G Dey",
    role: "Founder & Managing Director",
    qualifications: "B.E. (Civil), MBA",
    experience: "20+ years",
    spec: "Engineering Strategy, Hospitality, Retail",
    photo: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=85&w=1200",
    isFounder: true,
  },
  {
    name: "Anirban Sen",
    role: "Director – Engineering",
    qualifications: "M.Tech (Structural)",
    experience: "22 years",
    spec: "Structural Design, Seismic Engineering",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=85&w=1200",
  },
  {
    name: "Ria Bhattacharya",
    role: "Principal Architect",
    qualifications: "B.Arch, M.Arch (Urban)",
    experience: "16 years",
    spec: "Hospitality, Cultural, Urban Design",
    photo: "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?q=85&w=1200",
  },
  {
    name: "Vikram Rao",
    role: "Head – Project Management",
    qualifications: "B.E., PMP",
    experience: "18 years",
    spec: "Infrastructure PMC, Government Projects",
    photo: "https://images.unsplash.com/photo-1556157382-97eda2d62296?q=85&w=1200",
  },
  {
    name: "Lhingneichong Kipgen",
    role: "Lead – Survey & Investigation",
    qualifications: "M.Sc. (Geoinformatics)",
    experience: "12 years",
    spec: "Topography, LiDAR, GIS",
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=85&w=1200",
  },
  {
    name: "Dr. Meera Iyer",
    role: "Environmental Lead",
    qualifications: "Ph.D. (Environmental)",
    experience: "14 years",
    spec: "EIA, IGBC, Climate Adaptation",
    photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=85&w=1200",
  },
  {
    name: "Rohit Khatri",
    role: "Hospitality Consultant",
    qualifications: "MBA (Hospitality)",
    experience: "15 years",
    spec: "Hotel Feasibility, Operator Selection",
    photo: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=85&w=1200",
  },
  {
    name: "Pooja Nair",
    role: "Retail Strategist",
    qualifications: "MBA (Retail)",
    experience: "13 years",
    spec: "Catchment, Tenant Mix, VM",
    photo: "https://images.unsplash.com/photo-1573497161161-c3e73707e25c?q=85&w=1200",
  },
];
